export class WorkedDays {
  private nationalHoliday = [
    { day: [1] }, //janeiro
    { day: [0] },
    { day: [0] },
    { day: [2, 21] }, //abril
    { day: [1] }, // maio
    { day: [0] },
    { day: [0] },
    { day: [0] },
    { day: [7] }, //setembro
    { day: [12] }, // outubro
    { day: [2, 15] }, //novembro
    { day: [25] }, // dezembro
  ];

  private date = {
    currentDate: new Date().getDate(),
    currentMonth: new Date().getMonth(),
    currentYear: new Date().getFullYear(),
  };

  private isNotHoliday(day: number, month: number): boolean {
    return Boolean(!this.nationalHoliday[month].day.includes(day));
  }

  private positionDay(day: number, month?: number): number {
    const currentMonth = month || this.date.currentMonth
    return new Date(
      `${currentMonth + 1}/${day}/${this.date.currentYear}`
    ).getDay();
  }

  private isWorkingDays(day: number, month?: number): boolean {
    const currentMonth = month || this.date.currentMonth
    return Boolean(
      this.positionDay(day, currentMonth) > 0 &&
        this.positionDay(day) < 6 &&
        this.isNotHoliday(day, currentMonth)
    );
  }

  public calculateWorkingDaysInMonth(dateFrom?: number, dateTo?: number, month?: number ): number {
    const firstDay = dateFrom || 1
    const dayUse = dateTo || this.date.currentDate

    let workingDays = 0;
    for (let day = firstDay; day <= dayUse; day++)
      if (this.isWorkingDays(day, month)) workingDays++;

    return dateTo ? workingDays : workingDays - 1
  }
}

